import { inject }                                                 from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Profession }                      from '@shared/classes/profession';
import { ProfilEnum }                      from '@shared/enums/profil.enum';
import { forkJoin, Observable, switchMap } from 'rxjs';
import { map, take }                       from 'rxjs/operators';
import { TypeStepOneParameters }                                  from 'src/app/components/main/steps/step-one/step-one-parameters.resolver';
import { SharedService }                                          from 'src/app/shared/services/shared/shared.service';

export const MainResolver: ResolveFn<TypeStepOneParameters> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  _sharedService: SharedService = inject (SharedService)): Observable<TypeStepOneParameters> => {
    return _sharedService.getprofessions (ProfilEnum.OAV).pipe (
      take (1),
      switchMap( t => {
        return forkJoin([
          _sharedService.getprofessions (ProfilEnum.OAV),
          _sharedService.getprofessions (ProfilEnum.SELFCARE)
        ]);
      }),
      map (([professionsOAV, professionSelfcare]:[Profession[], Profession[]]) => {
        return {
          professionsOAV, professionSelfcare
        };
      }),
    );
}
